import type { CustomIconProps } from '../types';

const AddToBagAlternative = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '40'}
        height={height ?? '40'}
        viewBox="0 0 40 40"
        fill="none"
    >
        <path
            fill="#FCFBF8"
            stroke="#C6C6C6"
            strokeWidth={0.8}
            d="M20 .4C30.825.4 39.6 9.175 39.6 20c0 10.825-8.775 19.6-19.6 19.6C9.175 39.6.4 30.825.4 20 .4 9.175 9.175.4 20 .4Z"
        />
        <path
            fill="#414042"
            d="M26.002 22.297c.388 0 .703.317.703.707v1.853h1.84c.39 0 .704.317.704.707 0 .39-.315.706-.703.706h-1.84v1.94a.705.705 0 1 1-1.406 0v-1.94h-1.94a.705.705 0 0 1-.703-.706c0-.39.315-.707.703-.707h1.94v-1.853c0-.39.315-.707.703-.707ZM20.004 10c.973 0 1.76.226 2.379.63a3.54 3.54 0 0 1 1.28 1.522c.379.828.466 1.733.487 2.371H30l-.787 6.43a5.899 5.899 0 0 0-1.336-.658l.533-4.36h-4.25v2.751c0 .39-.316.707-.704.707a.705.705 0 0 1-.703-.707v-2.75h-5.497v2.75c0 .39-.315.707-.703.707a.705.705 0 0 1-.703-.707v-2.75h-4.26l1.249 10.198c.065.53.514.93 1.047.93h6.247c.095.496.25.97.459 1.413h-6.706a2.466 2.466 0 0 1-2.444-2.17L10 14.523h5.857c.025-.598.12-1.474.485-2.292.256-.573.654-1.142 1.27-1.564.619-.424 1.41-.667 2.392-.667Zm0 1.412c-.744 0-1.248.181-1.6.422-.354.243-.604.581-.779.975-.256.574-.334 1.215-.358 1.714h5.476c-.02-.545-.095-1.205-.358-1.78a2.132 2.132 0 0 0-.77-.928c-.351-.23-.86-.403-1.611-.403Z"
        />
    </svg>
);
export default AddToBagAlternative;
